import { ListChecks } from 'lucide-react'
import { Tooltip } from 'react-tooltip'
import { SessionManager } from '../../utils'

export default function ActionList(props) {

    const { text, route_name, onClick } = props

    var permission = JSON.parse(SessionManager.getSession('permission'))

    return (
        <>
            {permission?.some(val => val.sub_action_name === route_name) &&
                <ListChecks size={16} className='action_btn text-secondary me-3'
                    onClick={onClick}
                    data-tooltip-id='list'
                    data-tooltip-content={text}
                    data-tooltip-place="right"
                />
            }

            <Tooltip id='list' className='bg-secondary tooltip_msg' />
        </>
    )
}
